import * as moment from 'moment';

export function format(value: any, formatString: string) {
	if (value == null) {
		return '';
	}

	if (!formatString) {
		return value.toString();
	}

	if (isDate(value)) {
		return formatDate(value, formatString);
	}

	if (isNumber(value)) {
		return formatNumber(value, formatString);
	}

	return value.toString();
}

function formatDate(value: Date, formatString: string) {
	return moment(value).format(formatString);
}

function formatNumber(value: number, formatString: string) {
	const locale = 'fi-FI';
	const options = parseNumberFormatOptions(formatString);

	return value.toLocaleString(locale, options);
}

const isCurrency = /^c\d*$/;
const isPercent = /^c\d*$/;

function parseNumberFormatOptions(formatString: string) {
	if (isCurrency.test(formatString)) {
		return parseCurrencyFormatOptions(formatString);
	}

	if (isCurrency.test(formatString)) {
		return parseCurrencyFormatOptions(formatString);
	}

	return parseDecimalFormatOptions(formatString);
}

function parseCurrencyFormatOptions(formatString: string): Intl.NumberFormatOptions {
	const currency = 'EUR';

	const options = parseSpecialFormatOptions(formatString, isCurrency, 'currency');
	options.currency = currency;
	return options;
}

function parseSpecialFormatOptions(formatString: string, matcher: RegExp, style: string): Intl.NumberFormatOptions {
	const results = formatString.match(matcher);
	const fractionDigits = results.length === 2 ? parseInt(results[2], 10) : undefined;

	return {
		style: style,
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits
	};
}

function parsePercentFormatOptions(formatString: string): Intl.NumberFormatOptions {
	return parseSpecialFormatOptions(formatString, isPercent, 'percent');
}

function parseDecimalFormatOptions(formatString: string): Intl.NumberFormatOptions {
	throw new Error('Not implemented');
}

function isDate(value: any) {
	return value instanceof Date;
}

function isNumber(value: any) {
	return !isNaN(parseFloat(value)) && isFinite(value);
}
